export class Molel_CRM_Opportunity_List {

    public OpportunityId: number;
    public OpportunityName: string;

}